

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IDocument, IUser, IFileWrapper, Maybe, IFile } from '@/models';
import { BaseDetail } from '../Base/BaseDetail';
import { Prop } from 'vue-property-decorator';

const namespace = 'file';
const ns = { namespace };

@Component
export default class FilePreview extends BaseDetail<IFile> {
  @Prop({ default: false }) modal: boolean;
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IFile>;
  @Action('getEntity', ns) getEntity: any;
  @Action('createEntity', ns) createEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
  beforeDestroy() {
    this.$emit('close');
  }
  get modalPath() {
    return this.entity;
  }
  set modalPath(_) {
    this.$emit('close');
  }
}
